import React, { useState, useEffect, useContext } from 'react'
import Pregunta from '../Pregunta'

const Stepper = ({ data, activeQuestion }) => {
  return (
    <div>
      <Pregunta data={data[activeQuestion]} />
    </div>
  )
}

export default Stepper
